import { useMutation, useQueryClient } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { approvalQueueKeys } from './useApprovalQueue';
import { leaveKeys } from './useMijnVerlof';

/**
 * Story 7.8: HR stelt de einddatum vast (FR-31).
 *
 * De stand verandert niet — de aanvraag blijft op HR wachten — maar de
 * periode en de uren wel, en die staan in alle drie de lezers: de
 * goedkeuringslijst, het eigen overzicht van de medewerker en de
 * aanwezigheidskalender.
 */
export function useUpdateLeaveEndDate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, endDate }: { id: number; endDate: string }) =>
      verlofApi.updateEndDate(id, endDate),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: approvalQueueKeys.all });
      queryClient.invalidateQueries({ queryKey: leaveKeys.all });
      queryClient.invalidateQueries({ queryKey: ['aanwezigheidskalender'] });
    },
  });
}
